<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<div v-if="story" class="stories-page padding-top-20 padding-bottom-50">
			<div class="container">
				<div>
					<h1 class="story-title">
						{{ story.title }}
					</h1>
					<div class="story-author">{{ story.author }}</div>
					<div class="story-date">{{ story.created_at | formatDate(false) }}</div>
					<p class="story-text" v-html="story.text"></p>
				</div>

				<div class="margin-bottom-50 margin-top-30 text-center">
					<div class="container">
						<h3>{{ $t('Section.StoriesDetailSentence1') }}</h3>
						<router-link
							:to="{ path: '/registrazione-utente?redirect_to=/request/create/1', query: { code: code } }"
							class="button button-5 margin-top-20"
						>
							{{ $t('Navigation.RequestsCreate') }}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'StoriesDetail',
	components: {
		PageTitle,
	},
	mixins: [AccountInfo, PageInfo, ServiceHelper],
	props: {
		code: {
			type: String,
			required: true,
		},
		slug: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			pageByCode: true,
			pageBySlug: true,
			story: null,
		}
	},
	created() {
		// Retrieve story from API
		this.loadData()
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/stories/request-type/' + this.code + '/' + this.slug, {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.story = response.data.info
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/core/stories/StoriesDetail.vue